import angular from "angular";
import panel from "../services";

function blockUser (panel) {

    return {
        restrict: 'A',
        link: (scope, element, attrs) => {
            $(element).click(
                () => {
                    panel.confirm("Are you sure you want to block this user?", () => {
                        panel.post('/v1/block',{'blocked_id':attrs['userId']}, function(response){
                            if(panel.okay(response)){
                                panel.popup_remove();
                                panel.dashboard_message(response.message);
                            }
                        });
                    });
                }
            );
        },
    //    template: require('./templates/block-user.html')
    }
}

export default angular.module('directives.blockUser', [panel]).directive('blockUser', blockUser).name;



// WEBPACK FOOTER //
// ./src/app/directives/blockUser.js